// =============================================================================
// A single app-level signal: "loan data changed".
//
// Screens own their own rendering, but the shell shows an overdue badge that
// depends on data a screen just changed. Rather than let the shell poll, or
// wire screen-to-shell callbacks through every constructor, a transaction
// announces itself and whoever cares listens.
// =============================================================================

const EVENT = 'library:data-changed';

/** Call after any issue, return, renew or lost-mark. */
export const emitDataChanged = () => window.dispatchEvent(new CustomEvent(EVENT));

export const onDataChanged = (handler) => window.addEventListener(EVENT, handler);
